// Callback.js

import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; // If you're using React Router

const Callback = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Extract the grant token from the URL or Zoho response data
    const params = new URLSearchParams(window.location.href);
   //const code = params.get('code');
    const accessToken = params.get("access_token");
    const expiresIn = params.get('expires_in');
    console.log("Access Token: ",params.has("access_token"));
    if(accessToken) {
        localStorage.setItem('access_token',accessToken);
        localStorage.setItem('expires_in',expiresIn);
        const expirationTime = Date.now() + expiresIn * 1000; // Calculate expiration time in milliseconds
        localStorage.setItem('token_time', expirationTime);
        navigate('/invoices');
    }
    const groupedInvoices = {};
    
    {/*
    // Make a POST request to get the access token and refresh token
    axios
      .post('https://accounts.zoho.com/oauth/v2/token', null, {
        params: {
          code: code,
          redirect_uri: 'http://localhost:3000/callback', // Replace with your redirect URI
          client_id: '1000.6JRP941I5GCEFD3ER2G34J1DVB1ILA', // Replace with your client ID
          client_secret: '9eeba6d26290d5da271effbe5bc65bf18f8e486bf3', // Replace with your client secret
          grant_type: 'authorization_code',
        },
      })
      .then((response) => {
        const { access_token, refresh_token } = response.data;
        localStorage.setItem('access_token',access_token);
        localStorage.setItem('refresh_token',refresh_token);
        // Store the tokens in local storage or state as needed
        // You can use localStorage.setItem() to store them securely

        // Navigate to CustomerInvoices component
        navigate('/invoices');
      })
      .catch((error) => {
        console.error('Error fetching tokens:', error);
        // Handle error as needed
      });
    */}
  }, [location, navigate]);
    return (
    <div>
      <p>Handling Zoho response...</p>
    </div>
  );
};

export default Callback;
